<template>
  <b-modal v-bind:id="id"
           class="basic-modal"
           v-bind:title="title"
           v-bind:close-title="closeTitle || $t('common.cancel')"
           v-bind:ok-title="okTitle || $t('common.confirm')"
           v-on:ok="ok"
           v-on:cancel="cancel">
    <slot></slot>
  </b-modal>
</template>

<script>
  export default {
    name: 'basic-modal',

    props: {
      id: String,
      title: String,
      okTitle: {
        type: String,
        default: null,
      },
      closeTitle: {
        type: String,
        default: null,
      },
    },

    methods: {
      ok() {
        this.$emit('ok');
      },

      cancel() {
        this.$emit('cancel');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/BasicModal.vue